__turbopack_context__.v({
  "footerButton": "IncludeDetailSidebar-module__PNTE7q__footerButton",
  "footerQuantityButton": "IncludeDetailSidebar-module__PNTE7q__footerQuantityButton",
  "footerQuantityValue": "IncludeDetailSidebar-module__PNTE7q__footerQuantityValue",
  "footerQuantityWrapper": "IncludeDetailSidebar-module__PNTE7q__footerQuantityWrapper",
});
